import client from '@/lib/axios-client'
import type {
	DDSEmotionEntry,
	DDSEmotionListOutput,
	DDSEmotionListParams,
} from '@/types'

const DDS_URL = '/dds'

export async function getDDSEmotions(
	params?: DDSEmotionListParams,
): Promise<DDSEmotionListOutput> {
	const response = await client.get(`${DDS_URL}/emotions`, { params })
	return response.data.data
}

// action vazia limpa a ação registrada
export async function registerMoodAction(
	ddsId: string,
	attendeeId: string,
	action: string,
): Promise<DDSEmotionEntry> {
	const response = await client.patch(
		`${DDS_URL}/${ddsId}/attendees/${attendeeId}/mood-action`,
		{ action },
	)
	return response.data.data
}
